export default "__VITE_ASSET__1At4K_U0__"